import { render, staticRenderFns } from "./VerCliente.vue?vue&type=template&id=240f3310&"
import script from "./VerCliente.vue?vue&type=script&lang=js&"
export * from "./VerCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports